import { Get, Post } from "./apiService";
import {
  BASE_URL,
  SEARCH_PO_ENDPOINT,
  SEARCH_SUPPLIER_ENDPOINT,
  SOMS_API_KEY,
  SUPPLIER_V1_URL,
  SYSTEM_ERROR,
} from "./CONSTANTS";

export const getSuppliersApi = (request) => {
  let searchType = "Supplier";
  if (!isNaN(request.searchCriteria)) {
    searchType = "Site";
  }
  return new Promise((resolve, reject) => {
    try {
      request.url = `${SUPPLIER_V1_URL}${SEARCH_SUPPLIER_ENDPOINT}?searchCriteria=${request.searchCriteria}&searchType=${searchType}&apikey=${SOMS_API_KEY}`;
      Get(request)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchPOApi = (request) => {
  return new Promise((resolve, reject) => {
    try {
      let requestTypeParams = "";
      if(request.requestType){
        requestTypeParams = `&requestType=${request.requestType}`
      }
      request.url = `${BASE_URL}${SEARCH_PO_ENDPOINT}?limit=${request.limit}&offset=${request.offset}${requestTypeParams}&apikey=${SOMS_API_KEY}`;
      Post(request)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
